<template>
    <page :delegated-loading="true" :loading="!authenticated || $wait.waiting([keys.criterias.read, keys.effectiveness.list])" class="dashboard-index">
        <template #content>
            <template v-if="authenticated">
                <m-block-content-onboarding v-if="verified"/>
                <e-typography-heading-1>{{$t('pages.dashboard.index.title')}}</e-typography-heading-1>
                <m-accordion-dashboard v-if="$userRoles.isOwner ? verified : authenticated"/>
                <m-block-content-not-verified-dashboard v-else/>
            </template>
        </template>
    </page>
</template>

<script>
    import Page from "@pages/templates/page";
    import MAccordionDashboard from "@modules/accordions/concrete/m-accordion-dashboard";
    import MBlockContentNotVerifiedDashboard from "@modules/blocks/content/m-block-content-not-verified-dashboard";
    import vuexKeys from "@mixins/includes/_vuexKeys";
    import MBlockContentOnboarding from "@modules/blocks/content/m-block-content-onboarding";
    import ETypographyHeading1 from "@elements/typography/e-typography-heading-1";
    import { mapActions } from 'vuex'

    export default {
        name: "dashboard-index",
        mixins: [vuexKeys],
        components: {
            ETypographyHeading1,
            MBlockContentOnboarding,
            Page,
            MBlockContentNotVerifiedDashboard,
            MAccordionDashboard
        },
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.index.meta.title')
            }
        },
        props: {
            showECModal: {
                type: String,
                required: false
            }
        },
        methods: {
            ...mapActions({
                openModal: 'dialogs/open'
            }),
        },
        created() {
            if(this.showECModal) {
                this.$store.dispatch('effectiveness/setRedirectId', this.showECModal)
                this.$store.dispatch('onboardings/setOpenState', false)
               // this.openModal('redirectEfControl');
            }
        }
    }
</script>

<style lang="scss">
    .dashboard-index {
        .e-typography-heading-1 {
            padding: 2rem 0 2rem 0 ;
        }
        .container {
            padding: 0;
        }
    }
</style>
